import React, { useState } from "react";
import { Dialog } from "@mui/material";
import SubmitMonthlyReimbursementRequest from "./SubmitMonthlyReimbursementRequest";
import { CaseWhenBenefit } from "services/GraphQl";
import WhenBenefitMonthlyTracker from "./MonthlyBenefitTracker";

interface MonthlyBenefitSummaryProps {
  whenBenefit: CaseWhenBenefit;
  hasBankAccount: boolean;
  companyId: string;
  caseId: string;
  onReimbursementSubmitted?: () => void;
  setBankAccountModalOpen: (open: boolean) => void;
}

const MonthlyBenefitSummary: React.FC<MonthlyBenefitSummaryProps> = ({
  whenBenefit,
  hasBankAccount,
  companyId,
  caseId,
  onReimbursementSubmitted,
  setBankAccountModalOpen,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (whenBenefit?.distributionType !== "MONTHLY_ALLOCATION") return null;

  return (
    <>
      <WhenBenefitMonthlyTracker whenBenefit={whenBenefit} setModalOpen={setModalOpen} />
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <SubmitMonthlyReimbursementRequest
          hasBankAccount={hasBankAccount}
          whenBenefit={whenBenefit}
          companyId={companyId}
          caseId={caseId}
          onSave={() => {
            setModalOpen(false);
            onReimbursementSubmitted?.();
            setBankAccountModalOpen(true);
          }}
          onCancel={() => setModalOpen(false)}
        />
      </Dialog>
    </>
  );
};

export default MonthlyBenefitSummary; 